import type { CustomerOrderDetail } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { formatCalendarDate, formatDateTime } from '@/shared/lib';

interface OrderScheduleProps {
  /** 출고 예정일(달력 날짜) — 제작 착수 전이면 null. */
  readonly expectedShipDate: string | null;
  readonly delayNotices: CustomerOrderDetail['delayNotices'];
}

/** 배송 일정 — 출고 예정일과 운영자가 보낸 출고 지연 안내(이전 → 새 날짜·사유). 결제 정보와 같은 이름/값 줄. */
export const OrderSchedule = ({
  expectedShipDate,
  delayNotices,
}: OrderScheduleProps): ReactElement => (
  <section aria-label="배송 일정" className="flex flex-col gap-3">
    <p
      aria-hidden
      className="text-[11px] leading-none font-semibold tracking-[0.18em] text-muted-foreground uppercase"
    >
      Schedule
    </p>
    <dl className="divide-y divide-foreground/10 border-y border-foreground/10 text-sm">
      <div className="flex gap-4 py-3">
        <dt className="w-24 shrink-0 text-muted-foreground sm:w-28">출고 예정일</dt>
        <dd className="font-semibold tabular-nums">
          {expectedShipDate === null ? '미정' : formatCalendarDate(expectedShipDate)}
        </dd>
      </div>
    </dl>
    {delayNotices.length > 0 ? (
      <div className="flex flex-col gap-2">
        <p className="text-xs text-muted-foreground">출고 지연 안내</p>
        <ol className="divide-y divide-foreground/10 border-b border-foreground/10 text-sm">
          {delayNotices.map((notice) => (
            <li key={notice.id} className="flex flex-col gap-1 py-3">
              <p className="font-medium tabular-nums">
                {notice.previousDate === null ? '미정' : formatCalendarDate(notice.previousDate)} →{' '}
                {formatCalendarDate(notice.newDate)}
              </p>
              <p className="whitespace-pre-wrap text-muted-foreground wrap-anywhere">
                {notice.reason}
              </p>
              <p className="text-xs text-muted-foreground tabular-nums">
                {formatDateTime(notice.createdAt)} 안내
              </p>
            </li>
          ))}
        </ol>
      </div>
    ) : null}
  </section>
);
